<template>
 <v-app id="inspire" style="background-color : #F8F9FA">
  <div class="pr-6 pl-6">
    <titleAgency></titleAgency>
    <!-- กลุ่ม Tab กิจการ,องค์กร,นิติบุคคล -->
    <v-tabs
      v-model="tab"
      color="#2BA197"
      background-color="titlebackground"
    >
    <!-- underscore ใต้ชื่อ -->
    <v-tabs-slider class="ml-0" color="#2BA197"></v-tabs-slider>
    <v-tab v-for="item in items" :key="item.nameBusiness" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
      <span class="'ml-0'">{{ item.nameBusiness }}</span>
    </v-tab>
    <v-tabs-items
    class="pb-2 mb-3"
    v-model="tab"
    style="border-radius: 10px;">
      <!-- กิจการ -->
      <v-tab-item>
        <div class="my-5">
          <div>
            <filterBusiness class="mx-5 mt-5"/>
            <tableBusiness class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <!-- นิติบุคคล -->
      <v-tab-item>
        <div class="my-5">
          <div>
            <filterCorporation class="mx-5 mt-5"/>
            <tableCorporation class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
       <!-- องค์กร -->
      <v-tab-item>
        <div class="my-5">
          <div>
            <filterOrganization class="mx-5 mt-5"/>
            <tableOrganization class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</div>
 </v-app>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_manageapprovebusinessnew/_overview/title.vue'
import filterBusiness from '@/components/_manageapprovebusinessnew/_overview/filterBusiness.vue'
import filterOrganization from '@/components/_manageapprovebusinessnew/_overview/filterOrganization.vue'
import filterCorporation from '@/components/_manageapprovebusinessnew/_overview/filterCorporation.vue'
import tableBusiness from '@/components/_manageapprovebusinessnew/_overview/tableBusiness.vue'
import tableOrganization from '@/components/_manageapprovebusinessnew/_overview/tableOrganization.vue'
import tableCorporation from '@/components/_manageapprovebusinessnew/_overview/tableCorporation.vue'
export default {
  components: {
    titleAgency,
    filterBusiness,
    filterOrganization,
    filterCorporation,
    tableBusiness,
    tableOrganization,
    tableCorporation
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: null,
      items: [
        {
          id: 1,
          nameBusiness: 'กิจการ'
        },
        {
          id: 2,
          nameBusiness: 'นิติบุคคล'
        },
        {
          id: 3,
          nameBusiness: 'องค์กร' // ใช้ข้อมูลของกิจการ เนื่องจากยังไม่มีข้อมูลในระบบ
        }
      ],
      approveRole: localStorage.approveRole
      // items: [
      //   'ธุรกิจ(ร้านค้า)', 'นิติบุคคล'
      // ]
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // this.getReqBusinessCount()
  },
  beforeDestroy () {
    EventBus.$off('countManageBusiness')
    // EventBus.$off('setApproveRole')
  },
  mounted () {
    EventBus.$on('countManageBusiness', this.countBusiness)
    // EventBus.$on('setApproveRole', this.setApproveRole)
  },
  tab: function (val) {
    // EventBus.$emit('CheckTab', val)
    // EventBus.$off('opendialogmember')
    this.forceRerender()
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    // countBusiness (value) {
    //   this.items = value
    // },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      await this.getReqBusinessCount()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        localStorage.setItem('approveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', 'Admin')
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('approveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader')
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    },
    async getReqBusinessCount () {
      const obj = {
        role: this.approveRole
      }
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/companys/countBusinessAndReqBusiness`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          if (response.data.success) {
            // this.items = response.data.result.getReqBusiness
            // response.data.result.map((el, index) => {
            //   el.total = el.totalPending
            // })
          } else {
            // console.log(response)
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
